import { TreeItem, TreeItemProps } from "@mui/x-tree-view-pro";
import { Stack, Typography } from "@mui/material";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";

// Shared map populated by AbsenceGroupSorting before each render
export const absenceGroupColorMap = new Map<string, string>();

const AbsenceGroupTreeItem = (props: TreeItemProps) => {
  const color = absenceGroupColorMap.get(props.itemId);

  const label = (
    <Stack direction="row" sx={{ alignItems: "center" }} spacing={0.75}>
      {color && <BookmarkIcon sx={{ fontSize: "1.5rem", color }} />}
      <Typography variant="subtitle1" color="textSecondary">
        {props.label as string}
      </Typography>
    </Stack>
  );

  return (
    <TreeItem
      {...props}
      label={label}
      slots={{
        ...props.slots,
        iconContainer: ({ children, ...iconProps }) => (
          <Stack
            direction="row"
            alignItems="center"
            component="span"
            {...iconProps}
          >
            <DragIndicatorIcon
              sx={{ fontSize: "1.1rem", color: "text.secondary" }}
            />
            {children}
          </Stack>
        ),
      }}
    />
  );
};

export default AbsenceGroupTreeItem;
